<!--
 * @Author: 小月月 718644978@qq.com
 * @Date: 2023-03-03 15:11:35
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-06-12 16:21:34
 * @FilePath: \迈亚人力资源系统-前端\src\components\oa\set\setAdd.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="dashboard-text">
			<img src="../../../assets/oa/approve-back.png" alt="" style="margin-right: 5px;" @click="closeBack()">
			<span>OA设置</span>
		</div>
		<div class="dashboard-content" v-if="!detailShow">
			<el-form :inline="true" :model="ruleForm"
				style="position:relative;padding: 40px 0 10px 46px;border-bottom: 1px solid #C1C1C1;">
				<el-form-item label="审批流名称" class="items">
					<el-input v-model="ruleForm.approval_process_name" placeholder="请输入审批流名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="关联流程" class="items">
					<el-select v-model="ruleForm.approval_process_type" placeholder="请选择关联流程" style="width: 100%;"
						filterable>
						<el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注" class="items">
					<el-input v-model="ruleForm.remarks" placeholder="请输入备注" clearable></el-input>
				</el-form-item>
				<el-form-item v-if="tabIndex == 0">
					<el-button class="dashboard-button" @click="Save()" v-if="num == 1">保存</el-button>
					<el-button class="dashboard-button" @click="Update()" v-if="num == 2">修改</el-button>
				</el-form-item>
			</el-form>
			<div style="display: flex;">
				<div class="tab-wrap">
					<div class="tab" :class="tabIndex == index ? 'tabClass' : ''"
						:style="index == 0 ? 'border-left:none' : ''" v-for="(item, index) in tabList" :key="index"
						@click="tabClick(index)">
						<span>{{ item }}</span>
						<img class="oa-add" src="../../../assets/oa/add.png" alt="" v-if="index == 1" @click="addClick()">
					</div>
				</div>
				<div class="tab-hr"></div>
			</div>
			<el-form :inline="true" :model="ruleForm" v-if="tabIndex == 1">
				<div style="margin-bottom: 15px;" v-for="(item, index) in nodeList" :key="index">
					<el-scrollbar ref="myScrollbar" style="height: 360px;margin-right: 20px;" class="scrollbar"
						:vertical="false">
						<div style="display: flex;">
							<div v-for="(item1, index1) in item.conditionList" :key="index1"
								style="border: 1px solid #F3F3F3;margin-right: 15px;">
								<div class="oa-title">
									<div>
										<span>节点</span>
										<el-input v-model="item1.node" size="small" clearable
											style="width: 60px;"></el-input>
									</div>
									<img class="oa-delete" src="../../../assets/oa/delete.png" alt=""
										@click="delTwoClick(index, index1)">
								</div>
								<div class="oa-infor">
									<div class="infor-left">
										<el-radio-group style="margin: 24px 0;" v-model="item1.is_leadership">
											<el-radio :label="1">指定人
											</el-radio>
											<el-radio :label="2">角色</el-radio>
											<el-radio :label="3">自选人
											</el-radio>
										</el-radio-group>
										<div>
											<el-form-item v-if="item1.is_leadership == 1">
												<el-select v-model="item1.arr" filterable clearable multiple collapse-tags
													placeholder="请选择指定人" style="width: 100%;">
													<el-option v-for="(user, userIndex) in userList" :key="userIndex"
														:label="user.staff_name" :value="user.staff_id">
													</el-option>
												</el-select>
											</el-form-item>
											<el-form-item v-if="item1.is_leadership == 2">
												<el-select v-model="item1.brr" clearable multiple collapse-tags
													placeholder="请选择角色" style="width: 100%;">
													<el-option v-for="role in roleList" :key="role.id"
														:label="role.role_name" :value="role.id">
													</el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
									<div class="infor-right">
										<div class="infor-title">审批条件</div>
										<div style="margin: 0 40px;">
											<el-select v-model="item1.approval_condition_type" placeholder="请选择集成字段"
												style="width: 100%;" @change="changeList(index, index1, $event)">
												<el-option v-for="approvalType in approvalTypeList" :key="approvalType.id"
													:label="approvalType.fieldName" :value="approvalType.id">
												</el-option>
											</el-select>
										</div>
										<div style="margin: 24px 40px;">
											<el-radio-group v-model="item1.approval_criteria">
												<el-radio :label="1 + ''">大于</el-radio>
												<el-radio :label="2 + ''">小于</el-radio>
												<el-radio :label="3 + ''">等于</el-radio>
											</el-radio-group>
										</div>
										<div style="margin: 0 40px;">
											<el-form-item>
												<!-- <el-select v-model="item1.judgment" placeholder="请选择选项"
													style="width: 100%;">
													<el-option v-for="approval in item1.approvalTypeListTwo"
														:key="approval.id" :label="approval.detail_name"
														:value="approval.id">
													</el-option>
												</el-select> -->
												<el-cascader v-model="item1.judgment" placeholder="请选择选项"
													style="width: 100%;" :options="item1.approvalTypeListTwo"
													@change="changes" :props="{ checkStrictly: true }"></el-cascader>

												<el-input v-model="item1.ranges" style="margin-top: 10px;" type="textarea"
													:rows="2" disabled>
												</el-input>
											</el-form-item>
										</div>
									</div>
								</div>
							</div>
							<div class="approve-img">
								<img src="../../../../src/assets/审批+.png" alt="" style="width: 273px;height: 170px;"
									@click="addTwoClick(index, index1)">
								<img class="oa-del" src="../../../assets/oa/del.png" alt="" @click="delClick(index)">
							</div>
						</div>
					</el-scrollbar>
				</div>
			</el-form>

			<div v-show="tabIndex == 0">
				<!-- <v-form-designer ref="vfDesigner" :designer-config="designerConfig" :field-list-api="fieldListApi"
					:banned-widgets="bannedWidgets"></v-form-designer> -->
				<VFormDesigner ref="vfDesigner" :designer-config="designerConfig" :field-list-api="fieldListApi"
					:banned-widgets="bannedWidgets"></VFormDesigner>
			</div>
		</div>
	</div>
</template>

<script>
import VFormDesigner from './../../form-designer/index.vue'
import axios from "axios";
export default {
	props: ["stateText", "default", "List", "num"],
	components: { VFormDesigner },
	data() {
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
			return organizeList.data;
		};
		return {
			formJson: { "widgetList": [], "formConfig": { "labelWidth": 80, "labelPosition": "left", "size": "", "labelAlign": "label-left-align", "cssCode": "", "customClass": "", "functions": "", "layoutType": "PC", "onFormCreated": "", "onFormMounted": "", "onFormDataChange": "" } },
			formData: {},
			optionData: {},
			options: [
				{
					value: 'zhinan',
					label: '指南',
					children: [{
						value: 'shejiyuanze',
						label: '设计原则',
						children: [{
							value: 'yizhi',
							label: '一致'
						}, {
							value: 'fankui',
							label: '反馈'
						}, {
							value: 'xiaolv',
							label: '效率'
						}, {
							value: 'kekong',
							label: '可控'
						}]
					}, {
						value: 'daohang',
						label: '导航',
						children: [{
							value: 'cexiangdaohang',
							label: '侧向导航'
						}, {
							value: 'dingbudaohang',
							label: '顶部导航'
						}]
					}]
				}
			],

			ruleForm: {
				approval_process_name: '',
				approval_process_type: '',
				remarks: '',
			},
			nodeList: [
				{
					conditionList: [
						{
							node: '',//节点
							role_id: '',
							is_leadership: '',//审批人类型 1为指定人 2为指定角色 3为自选人
							approved_by: '',//审批人ids 以逗号分隔
							ids: [],//审批人ids数组
							approval_condition_type: '',//审批条件类型
							approval_criteria: '3', //审批条件( 1为大于  2为小于  3为等于 )
							judgment_conditions: '',//判断条件以逗号分隔
							organizeIds_num: [],//判断条件数组
							arr: [],
							brr: [],
							approvalTypeListTwo: [],
							ranges: '',
							judgment: ''
						},
					]
				},
			],
			props: {
				lazy: true,
				async lazyLoad(node, resolve) {
					if (node.level === 0) {
						return resolve(await organizeFind('', 'group'));
					} else {
						resolve(await organizeFind(node.data.id, ''));
					}
				},
				value: "id",
				label: "organize_name",
				children: "organizeList",
				checkStrictly: true,
				multiple: true,
			},

			designerConfig: {
				// 是否显示语言切换菜单
				languageMenu: false,
				// 是否显示GitHub、文档等外部链接
				externalLink: false,
				// 是否显示表单模板
				formTemplates: true,
				// 是否禁止修改唯一名称
				widgetNameReadonly: false,
				// 是否显示组件事件属性折叠面板
				eventCollapse: false,
				// 是否显示清空设计器按钮
				clearDesignerButton: true,
				// 是否显示预览表单按钮
				previewFormButton: true,
				// 是否显示导入JSON按钮
				importJsonButton: false,
				// 是否显示导出JSON器按钮
				exportJsonButton: false,
				// 是否显示导出代码按钮
				exportCodeButton: false,
				// 是否显示生成SFC按钮
				generateSFCButton: false,
				// 工具按钮栏最大宽度（单位px）
				toolbarMaxWidth: 180,
				// 工具栏按钮最小宽度（单位px）
				toolbarMinWidth: 180,
				// 表单设计器预设CSS代码
				presetCssCode: '',
				// 表单设计器初始化自动清空内容
				resetFormJson: true,
			},

			fieldListApi: {
				URL: this.$globals.http + 'OaManageSet/getDesigner',
				nameKey: 'fieldLabel',
				labelKey: 'fieldName'
			},

			bannedWidgets: ['table', 'switch'],

			tabList: ['表单设计', '审批流程'],
			tabIndex: 0,
			//指定人
			userList: [],
			//保险类别
			insuranceTypeList: [],
			//审批条件
			approvalTypeList: [],
			approvalTypeListTwo: [],
			//组织架构数据
			organizeList: [],
			//角色
			roleList: [],
			//岗位数据
			postList: [],
			//动态审批节点
			objestSize: [1],
			objestSize2: [1],
			approvalType: [{
				name: "",
				value: ""
			}],

			//类型下拉
			typeList: [{
				value: 1,
				label: "加班审批"
			},
			{
				value: 2,
				label: "请假审批"
			},
			{
				value: 3,
				label: "岗位支援审批"
			},
			{
				value: 4,
				label: "离职审批"
			},
			{
				value: 5,
				label: "代岗审批"
			},
			{
				value: 6,
				label: "外出审批"
			},
			{
				value: 7,
				label: "调薪审批"
			},
			{
				value: 8,
				label: "补卡审批"
			},
			{
				value: 9,
				label: "出差审批"
			},
			{
				value: 10,
				label: "处罚审批"
			},
			{
				value: 11,
				label: "入职审批"
			},
			{
				value: 12,
				label: "调岗审批"
			},
			{
				value: 13,
				label: "转正审批"
			},
			{
				value: 14,
				label: "工资明细审批"
			},
			{
				value: 15,
				label: "工资占比审批"
			},
			{
				value: 16,
				label: "工资汇总审批审批"
			},
			{
				value: 17,
				label: "预算编制审批"
			},
			{
				value: 18,
				label: "预算编制月度审批"
			},
			{
				value: 19,
				label: "保证金审批"
			},
			{
				value: 20,
				label: "冲账审批"
			},
			{
				value: 21,
				label: "转化履约金审批"
			},
			{
				value: 22,
				label: "履约金审批"
			},
			{
				value: 23,
				label: "预算执行"
			}
			],

			total: 0,
			showDialog: false,
			width: "",
			title: "",
			selectId: [],
			detailShow: false,
			detailState: '3', //1已同意3待审批

			forms: {}
		}
	},
	mounted() {
		if (this.stateText == 0) this.tabIndex = 0
		if (this.stateText == 1) this.tabIndex = 2
		if (this.stateText == 2) this.tabIndex = 1
		if (this.stateText == 3) this.tabIndex = 3
	},
	methods: {
		changes(e) {
			console.log(e);
		},
		async changeList(index, index1, e) {
			console.log(this.nodeList);
			console.log(index, index1, e)
			var approvalTypeListTwo = await this.$globals.AxiosGet("OaManageDesignerDetail/getList?info=" + e);
			approvalTypeListTwo.data.map(item => {
				// if(item.children.length == 0) delete item.children
			})
			this.nodeList[index].conditionList[index1].approvalTypeListTwo = approvalTypeListTwo.data;
		},
		addClick() {
			let arr = {
				conditionList: [
					{
						node: '',//节点
						role_id: '',
						is_leadership: '',//审批人类型 1为指定人 2为指定角色 3为自选人
						approved_by: '',//审批人ids 以逗号分隔
						ids: [],//审批人ids数组
						approval_condition_type: '',//审批条件类型
						approval_criteria: '3', //审批条件( 1为大于  2为小于  3为等于 )
						judgment_conditions: '',//判断条件以逗号分隔
						organizeIds_num: [],//判断条件数组
						arr: [],
						brr: [],
						approvalTypeListTwo: [],
						ranges: '',
						judgment: ''
					},
				]
			}
			this.nodeList.push(arr)
		},
		delClick(index) {
			this.nodeList.splice(index, 1)
		},
		addTwoClick(index, index1) {
			let arr = {
				node: '',//节点
				role_id: '',
				is_leadership: '',//审批人类型 1为指定人 2为指定角色 3为自选人
				approved_by: '',//审批人ids 以逗号分隔
				ids: [],//审批人ids数组
				approval_condition_type: '',//审批条件类型
				approval_criteria: '3', //审批条件( 1为大于  2为小于  3为等于 )
				judgment_conditions: '',//判断条件以逗号分隔
				organizeIds_num: [],//判断条件数组
				arr: [],
				brr: [],
				approvalTypeListTwo: [],
				ranges: '',
				judgment: ''
			}
			this.nodeList[index].conditionList.push(arr)
		},
		delTwoClick(index, index1) {
			this.nodeList[index].conditionList.splice(index1, 1)
		},
		//初始化组织架构及下面的人
		async organizeFind() {
			var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
				identification: "1",
			});
			this.organizeList = this.getTreeData(organizeList.data);
		},
		getTreeData(data) {
			// 循环遍历json数据
			for (var i = 0; i < data.length; i++) {

				if (data[i].organizeList.length < 1) {
					// children若为空数组，则将children设为undefined
					data[i].organizeList = undefined;
				} else {
					// children若不为空数组，则继续 递归调用 本方法
					this.getTreeData(data[i].organizeList);
				}
			}
			return data;
		},
		//添加审批节点
		AddRecord() {
			this.objestSize.push(1)
			this.$set(this.ruleForm.oaManageSetDetails, this.ruleForm.oaManageSetDetails.length, {
				node: this.ruleForm.oaManageSetDetails.length,
				role_id: "",
				is_leadership: 1,
				ids: null
			});
		},
		//添加审批条件
		AddRecord2() {
			this.objestSize2.push(1)
			this.$set(this.ruleForm.oaManageSetCriterias, this.ruleForm.oaManageSetCriterias.length, {
				node: this.ruleForm.oaManageSetCriterias.length,
				approval_condition_type: "1",
				approval_criteria: "3",
				judgment_conditions: "",
				ids: null
			});
		},
		//移除审批节点
		RemoveRecord(e) {
			this.objestSize.splice(e, 1);
			this.ruleForm.oaManageSetDetails.splice(e, 1);
		},
		//移除审批条件
		RemoveRecord2(e) {
			this.objestSize2.splice(e, 1);
			this.ruleForm.oaManageSetCriterias.splice(e, 1);
		},
		spjdchange(index) {
			this.ruleForm.oaManageSetDetails[index].ids = [];
		},
		sptjchange(index) {
			this.ruleForm.oaManageSetCriterias[index].ids = [];
			this.ruleForm.oaManageSetCriterias[index].judgment_conditions = "";
		},
		tabClick(index) {
			this.tabIndex = index
		},
		closeBack() {
			if (this.detailShow) {
				this.detailShow = false;
			} else {
				this.$emit('closeBack')
			}
		},
		clickBtn(type, item) {
			console.log(item);
			let that = this;
			const TYPE_METHODS = {
				["DETAIL"]() {
					that.detailShow = true;
				},
			};
			TYPE_METHODS[type]();
		},
		Save() {
			this.ruleForm.form = this.$refs.vfDesigner.getFormJson();
			const url = this.$globals.http + "OaManageSet/add";
			console.log(this.nodeList);
			this.nodeList.map(item => {
				item.conditionList.map(item1 => {
					if (item1.arr.length != 0) item1.ids = item1.arr
					if (item1.brr.length != 0) item1.ids = item1.brr
					item1.organizeIds_num = []
					if (item1.judgment) item1.organizeIds_num.push(item1.judgment[item1.judgment.length - 1])
					item1.judgment_conditions = item1.organizeIds_num.join(',')
				})
			})
			console.log(this.nodeList);
			axios.post(url, {
				approval_process_name: this.ruleForm.approval_process_name,
				approval_process_type: this.ruleForm.approval_process_type,
				remarks: this.ruleForm.remarks,
				nodeList: this.nodeList,
				form: this.ruleForm.form,
			}).then((response) => {
				var code = response.data.code;
				var data = response.data.data;

				if (code === '200') {
					this.$message.success(data);
					this.closeBack()

				} else {
					this.$message.warning(data);
				}
			}).catch((error) => {
				console.log(error)
				this.$message.error("服务器未响应！请稍后重试");
			})
		},
		Update() {
			console.log(this.$refs.vfDesigner.getFormJson());
			this.ruleForm.form = this.$refs.vfDesigner.getFormJson();
			const url = this.$globals.http + "OaManageSet/update";

			console.log(this.nodeList);
			this.nodeList.map(item => {
				item.conditionList.map(item1 => {
					item1.organizeIds_num = []
					if (item1.arr && item1.arr.length != 0) item1.ids = item1.arr
					if (item1.brr && item1.brr.length != 0) item1.ids = item1.brr
					if (item1.judgment) {
						item1.organizeIds_num = []
						item1.organizeIds_num.push(item1.judgment[item1.judgment.length - 1])
						item1.judgment_conditions = item1.organizeIds_num.join(',')
					}
				})
			})
			console.log(this.nodeList);

			axios.post(url, {
				id: this.List.id,
				approval_process_name: this.ruleForm.approval_process_name,
				approval_process_type: this.ruleForm.approval_process_type,
				remarks: this.ruleForm.remarks,
				nodeList: this.nodeList,
				form: this.ruleForm.form,
				// form: this.forms,
			}).then((response) => {
				var code = response.data.code;
				var data = response.data.data;

				if (code === '200') {
					this.$message.success(data);
					this.closeBack()

				} else {
					this.$message.warning(data);
				}
			}).catch((error) => {
				console.log(error)
				this.$message.error("服务器未响应！请稍后重试");
			})
		},
	},
	async created() {
		//初始化角色下拉
		var roleList = await this.$globals.AxiosPost("role/selectFind", {});
		this.roleList = roleList.data;

		var userList = await this.$globals.AxiosPost("user/selectFind", {});
		this.userList = userList.data;

		//初始化审批条件下拉
		var approvalTypeList = await this.$globals.AxiosGet("OaManageDesigner/getList");
		this.approvalTypeList = approvalTypeList.data;

		var postList = await this.$globals.AxiosPost('post/selectFind', {});
		this.postList = postList.data;

		//初始化保险类别
		var insuranceTypeList = await this.$globals.AxiosPost("dictionaries/selectFind", {
			data_grouping: "insurance_type"
		});
		this.insuranceTypeList = insuranceTypeList.data;

		console.log(this.List, '22')
		this.ruleForm = this.List;
		// 回显
		if (this.List.id) {
			var detailObject = await this.$globals.AxiosGet("OaManageSet/findFormByIdOne?info=" + this.List.id);
			detailObject.data.nodeList.map(item => {
				item.conditionList.map(item1 => {
					if (item1.is_leadership == 1) item1.arr = item1.ids
					if (item1.is_leadership == 2) item1.brr = item1.ids
					item1.approvalTypeListTwo = []
				})
			})

			this.nodeList = detailObject.data.nodeList;
			this.forms = detailObject.data.form;
			this.$refs.vfDesigner.setFormJson(this.forms)
			console.log(this.$refs.vfDesigner.getFormJson());
		}
	},
	watch: {
		"data"(newVal) {
			// this.ruleForm = newVal;
		}
	}
}
</script>

<style>
.items .el-form-item__label {
	font-size: 16px;
}
</style>
<style scoped>
.oa-title {
	width: 565px;
	background: #F3F3F3;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 20px;
	font-size: 15px;
}

.oa-delete {
	width: 24px;
	height: 24px;
}

.oa-add {
	width: 30px;
	height: 30px;
	margin-left: 5px;
}

.oa-del {
	width: 24px;
	height: 24px;
	position: absolute;
	right: 10px;
	top: 10px;
}

.oa-infor {
	display: flex;

}

.infor-left {
	width: 300px;
	text-align: center;
}

.infor-right {
	width: 300px;
}

.infor-title {
	font-size: 15px;
	margin: 16px 40px;
}

.approve-img {
	display: flex;
	align-items: center;
	position: relative;
}

.condition-title {
	font-size: 14px;
	text-align: left;
	margin: 15px 0 10px 0;
}

.node-wrap {
	margin: 30px 40px;
	display: flex;
	flex-wrap: wrap;
}

.node-img-wrap {
	width: 20%;
	height: 178px;
}

.node-img {
	width: 100%;
	height: 100%;
}

.node {
	border: 1px solid #C1C1C1;
	width: 20%;
	border-radius: 5px;
	margin: 0 20px 20px 0;
	overflow: hidden;
}

.node-title {
	line-height: 38px;
	background: #F3F3F3;
	font-size: 14px;
	padding: 0 15px;
}

.node-radio {
	text-align: center;
	margin: 26px 6% 16px 6%;
	border: 1px solid red;
}

.node-select {
	text-align: center;
	width: 80%;
	margin: 0 10% 38px 10%;
}

.node-textarea {
	text-align: center;
	width: 80%;
	margin: -20px 10% 20px 10%;
}

.tab-wrap {
	display: flex;
	align-items: center;
}

.tab {
	width: 110px;
	line-height: 38px;
	text-align: center;
	font-size: 14px;
	border-bottom: 1px solid #F7F6F9;
	display: flex;
	align-items: center;
	justify-content: center;
}

.tabClass {
	border-top: 2px solid #006E4B;
	border-left: 1px solid #F7F6F9;
	border-right: 1px solid #F7F6F9;
	border-bottom: 1px solid transparent;
	display: flex;
	align-items: center;
	justify-content: center;
}

.tab-hr {
	border-bottom: 1px solid #F7F6F9;
	width: calc(100vw - 440px);
	background: #FBFBFD;
}

.dashboard-text {
	font-size: 20px;
	/* margin: 30px 0 -5px 40px; */
	line-height: 50px;
	font-weight: 600;
	display: flex;
	align-items: center;
	background: #fff;
	border-bottom: 1px solid #C1C1C1;
}

.dashboard-content {
	background: #fff;
	font-size: 16px;
	border: 1px solid transparent;
	/* margin: 0 40px; */
}

.dashboard-button {
	width: 85px;
	background: #006E4B;
	color: #FFFFFF;
	border: 1px solid #006E4B;
}

.dashboard-buttonWhite {
	width: 85px;
	color: #006E4B;
	border: 1px solid #006E4B;
}
</style>



// WEBPACK FOOTER //
// setAdd.vue?44f0faee